import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { LazyImage } from '~/components/LazyImage';
import { LazyYoutubeVideo } from '~/components/LazyYoutubeVideo';
import { YT_ASPECT_RATIO } from '~/constants';
import { contentType } from '~/types';

const propTypes = {
  alt: PropTypes.string,
  canPlayVideo: PropTypes.bool,
  content: contentType,
  contentPreviewedId: PropTypes.string,
};

export const YoutubePreviewCard = ({
  alt = 'YouTube video preview',
  canPlayVideo = false,
  content,
  contentPreviewedId = null,
  ...containerProps
}) => (
  <Box
    borderRadius={{ base: 'sm', sm: 'md', md: 'lg' }}
    height="100%"
    overflow="hidden"
    {...containerProps}
  >
    {canPlayVideo ? (
      <LazyYoutubeVideo content={content} id={contentPreviewedId} />
    ) : (
      <LazyImage
        ratio={YT_ASPECT_RATIO}
        src={content?.thumbnails?.high?.url}
        imageProps={{ alt, id: contentPreviewedId }}
      />
    )}
  </Box>
);

YoutubePreviewCard.propTypes = propTypes;
